__turbopack_context__.v({
  "alignRight": "fileVisibility-module-scss-module__HYPASq__alignRight",
  "centered": "fileVisibility-module-scss-module__HYPASq__centered",
  "fileVisibility": "fileVisibility-module-scss-module__HYPASq__fileVisibility",
  "public": "fileVisibility-module-scss-module__HYPASq__public",
  "wrapper": "fileVisibility-module-scss-module__HYPASq__wrapper",
});
